import { BaseModel } from "@/interfaces/api";
import { UserDepartment } from "@/types/department";
import { generateOptionsFromEnum } from "@/utils/enum-options";

export { UserDepartment };

export enum UserRoleEnum {
  ADMINISTRATOR = "ADMINISTRATOR",
  COORDINATOR = "COORDINATOR",
  BOOKER = "BOOKER",
  RELATIONSHIP_COORDINATOR = "RELATIONSHIP_COORDINATOR",
  RELATIONSHIP_ANALYST = "RELATIONSHIP_ANALYST",
  RECEPTIONIST = "RECEPTIONIST",
  PHOTOGRAPHER = "PHOTOGRAPHER",
  PRODUCER = "PRODUCER",
  ART_PRODUCER = "ART_PRODUCER",
  OPERATOR = "OPERATOR",
}

export const UserRoleTranslations: Record<UserRoleEnum, string> = {
  [UserRoleEnum.ADMINISTRATOR]: "Administrador",
  [UserRoleEnum.COORDINATOR]: "Coordenador",
  [UserRoleEnum.BOOKER]: "Booker",
  [UserRoleEnum.RELATIONSHIP_COORDINATOR]: "Coordenador de relacionamento",
  [UserRoleEnum.RELATIONSHIP_ANALYST]: "Analista de relacionamento",
  [UserRoleEnum.RECEPTIONIST]: "Recepcionista",
  [UserRoleEnum.PHOTOGRAPHER]: "Fotógrafo",
  [UserRoleEnum.PRODUCER]: "Produtor",
  [UserRoleEnum.ART_PRODUCER]: "Produtor artístico",
  [UserRoleEnum.OPERATOR]: "Operador",
};

export const userRoleOptions = generateOptionsFromEnum(UserRoleTranslations);

export const UserDepartmentTranslations: Record<UserDepartment, string> = {
  [UserDepartment.CASTING]: "Casting",
  [UserDepartment.REBOUCAS]: "Rebouças",
  [UserDepartment.FRADIQUE]: "Fradique",
  [UserDepartment.PHOTO_LAB]: "Laboratório",
};

export const userDepartmentOptions = generateOptionsFromEnum(UserDepartmentTranslations);

export enum UserStatus {
  UNCONFIRMED_EMAIL = "UNCONFIRMED_EMAIL",
  ACTIVE = "ACTIVE",
  BLOCKED = "BLOCKED",
}

export enum PermissionController {
  Users = "Users",
}

export interface UserEmailLookup {
  id: string;
  name: string | null;
  hasAnyPosition: boolean;
  isAlreadyCollaborator: boolean;
}

export interface DeleteUserResponse {
  deletedUser: boolean;
  deletedAsAdministrator: boolean;
  remainingDepartments: UserDepartment[];
}

export interface UserPosition {
  userId: string;
  department: UserDepartment;
  role: UserRoleEnum;
  isAvailable: boolean;
  createdDate: string;
}

export interface User extends BaseModel {
  positions: UserPosition[];
  status: UserStatus;
  email: string;
  name: string;
  emailConfirmationCode: string | null;
  emailConfirmationCodeExpirationDate: Date | null;
  passwordResetCode: string | null;
  passwordResetCodeExpirationDate: Date | null;
  failedLoginAttempts: number;
  cpf: string;
  profilePictureUrl?: string | null;
  invitationEmailSent?: boolean;
}
